"use strict";

var _ = require("../lodash"),
    rankUtil = require("./util"),
    longestPath = rankUtil.longestPath,
    feasibleTree = require("./feasible-tree"),
    networkSimplex = require("./network-simplex");

module.exports = rank;

/*
 * Assigns a rank to each node in the input graph that respects the "minlen"
 * constraint specified on edges between nodes.
 *
 * This basic structure is derived from Gansner, et al., "A Technique for
 * Drawing Directed Graphs."
 *
 * Pre-conditions:
 *
 *    1. Graph must be a connected DAG
 *    2. Graph nodes must be objects
 *    3. Graph edges must have "weight" and "minlen" attributes
 *
 * Post-conditions:
 *
 *    1. Graph nodes will have a "rank" attribute based on the results of the
 *       algorithm. Ranks can start at any index (including negative), we'll
 *       fix them up later.
 */
function rank(g) {
  switch(g.graph().ranker) {
    case "network-simplex": networkSimplexRanker(g); break;
    case "tight-tree": tightTreeRanker(g); break;
    case "atl-override-order": atlOverrideOrder(g); break;
    case "longest-path": longestPathRanker(g); break;
    default: networkSimplexRanker(g);
  }
}

// A fast and simple ranker, but results are far from optimal.
var longestPathRanker = longestPath;

function tightTreeRanker(g) {
  longestPath(g);
  feasibleTree(g);
}

function networkSimplexRanker(g) {
  networkSimplex(g);
}

/*
 * This is a custom ranker we have patched in to Jira Frontend in order to base ranking off the depth of the current node from the root node.
 * ONLY makes sense in a tree graph.
 */
function atlOverrideOrder(g) {
    var visited = {}; // Stores the visited nodes
  
    // Depth-first search function that calculates the rank of the given node v
    function dfs(v) {
      var label = g.node(v);
      if (_.has(visited, v)) {
        return label.rank;
      }
      visited[v] = true;
  
      var rank = 0; // Initialize the rank for the current node
  
      // Iterate over incoming edges to the current node
      _.forEach(g.inEdges(v), function(e) {
        rank = Math.max(rank, dfs(e.v) + g.edge(e).minlen + 1); // Set the rank to 1 more than the parent's rank
      });
  
      // Set the rank of the current node and return it
      return (label.rank = rank);
    }
  
    // Iterate over all nodes in the graph and call the dfs function for nodes with a defined order
    g.nodes().forEach(function(v) {
      dfs(v);
    });
  }
